import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPieChart, faBarChart } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import PdmcUsecaseSidebar from "../Common/PdmcUsecaseSidebar";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
function PdmcAnalyticB() {
 
  const [cropGroupData, setCropGroupData] = useState([]);
  const [cropNameData, setCropNameData] = useState([]);
  const [cropVarietyData, setCropVarietyData] = useState([])
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  const [yearValue, setYearValue] = useState("");
  const [cropGroupValue, setCropGroupValue] = useState("");
  const [cropNameValue, setCropNameValue] = useState("");
  const [cropVarietyValue, setCropVarietyValue] = useState("")
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");

  const [totalArea, setTotalArea] = useState([]);
  const [miArea, setMiArea] = useState([]);
  const [oiArea, setOiArea] = useState([]);
  const [pdmcData, setPDMCData] = useState([]);

  const [stateArray, setStateArray] = useState([]);
  const [sprinklerArea, setSprinklerArea] = useState([]); 
  const [dripArea, setDripArea] = useState([]);
  const [totalAreaMi, setTotalAreaMi] = useState([]);
  
  const [pipesArea, setPipesArea] = useState([]);
  const [whsArea, setWhsArea] = useState([]);
  const [wldArea, setWldArea] = useState([]);
  const [tboArea, setTboArea] = useState([]);
  const [totalAreaOi, setTotalAreaOi] = useState([])

  const [chartToggle, setChartToggle] = useState(true);
  const [chartToggleSecond, setChartToggleSecond] = useState(true);

  

  useEffect(() => {
 
    fetchData();
  }, []);

  const fetchData = async (value) => {
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/DashboardPdmc/GetPdmcDashboardAreaIrrigationWiseDetails`,
      {
        "finYear": value === "reset" || yearValue === "Choose..." ? "" : yearValue,
"cropGroupCode": value === "reset" || cropGroupValue === "Choose..."? "" : cropGroupValue,
"cropNameCode": value === "reset" || cropNameValue === "Choose..." ? "" : cropNameValue,
"stateLgdCode": value === "reset"  || stateValue === "Choose..." ? "" : stateValue,
"districtLgdCode": value === "reset"  || districtValue === "Choose..." ? "" : districtValue,
"blockLgdCode": value === "reset" || blockValue === "Choose..."  ? "" : blockValue,
"villageLgdCode": value === "reset" || villageValue === "Choose..." ? "" : villageValue
      }
    );

  let stateArrayLocal = [];
  let sprinklerAreaLocal = []
  let dripAreaLocal = []
  let totalAreaMiLocal = []

  let pipesAreaLocal =[]
  let whsAreaLocal =[];
  let wldAreaLocal = [];
  let tboAreaLocal = [];
  let totalAreaOiLocal = [];

    if (result) {
      setPDMCData(result.data.dataContent);
      result.data.dataContent.map((item, index) => {
        if(item.villageName != "") {
          stateArrayLocal.push(item.villageName);
        } else if(item.subDistrictName != ""){
          stateArrayLocal.push(item.subDistrictName);
        } else if(item.districtName != "") {
          stateArrayLocal.push(item.districtName);
        } else if(item.stateName != "") {
          stateArrayLocal.push(item.stateName);
        }
        // stateArrayLocal.push(item.stateName);

        console.log("item.areas.irrigate[0].totalIrrigateArea", item.areas.irrigate[0].totalIrrigateArea)

        if(item.areas.irrigate[0].totalIrrigateArea === 0) {
          sprinklerAreaLocal.push("0")
          dripAreaLocal.push("0")
          totalAreaMiLocal.push("0")

        }else {
          totalAreaMiLocal.push(item.areas.irrigate[0].totalIrrigateArea)
          let subTypeLocal = [];
          let areaLocal = [];
          item.areas.irrigate[0].subIrrigates &&  item.areas.irrigate[0].subIrrigates.map((item, index) => {
            subTypeLocal.push(item.subType);
            areaLocal.push(item.area);   
          }) 
         if(subTypeLocal.includes("1")) {
          let index = subTypeLocal.indexOf("1")
          dripAreaLocal.push(areaLocal[index])
         }else {
          dripAreaLocal.push("0")
         }
         if(subTypeLocal.includes("2")) {
          let index = subTypeLocal.indexOf("2")
          sprinklerAreaLocal.push(areaLocal[index])
         }else {
          sprinklerAreaLocal.push("0")
         }
         console.log("subTypeLocal", subTypeLocal, areaLocal)
        }  
        
        if(item.areas.irrigate[1].totalIrrigateArea === 0) {
        
          totalAreaOiLocal.push("0")
          pipesAreaLocal.push("0")
          whsAreaLocal.push("0")
          wldAreaLocal.push("0")
          tboAreaLocal.push("0")

        }else {
          totalAreaOiLocal.push(item.areas.irrigate[1].totalIrrigateArea)
          let subTypeLocal = [];
          let areaLocal = [];
          item.areas.irrigate[1].subIrrigates && item.areas.irrigate[1].subIrrigates.map((item, index) => {
            subTypeLocal.push(item.subType);
            areaLocal.push(item.area);   
          }) 
         if(subTypeLocal.includes("3")) {
          let index = subTypeLocal.indexOf("3")
          whsAreaLocal.push(areaLocal[index])
         }else {
          whsAreaLocal.push("0")
         }
         if(subTypeLocal.includes("4")) {
          let index = subTypeLocal.indexOf("4")
          tboAreaLocal.push(areaLocal[index])
         }else {
          tboAreaLocal.push("0")
         }
         if(subTypeLocal.includes("5")) {
          let index = subTypeLocal.indexOf("5")
          wldAreaLocal.push(areaLocal[index])
         }else {
          wldAreaLocal.push("0")
         }
         if(subTypeLocal.includes("6")) {
          let index = subTypeLocal.indexOf("2")
          pipesAreaLocal.push(areaLocal[index])
         }else {
          pipesAreaLocal.push("0")
         }
        }
      });
    }
    setStateArray(stateArrayLocal);
    setSprinklerArea(sprinklerAreaLocal)
    setDripArea(dripAreaLocal)
    setTotalAreaMi(totalAreaMiLocal)
    setPipesArea(pipesAreaLocal)
    setWhsArea(whsAreaLocal)
    setWldArea(wldAreaLocal)
    setTboArea(tboAreaLocal)
    setTotalAreaOi(totalAreaOiLocal)

console.log("stateArrayLocal", stateArrayLocal)
console.log("sprinklerAreaLocal", sprinklerAreaLocal);
console.log("dripAreaLocal", dripAreaLocal);
console.log("totalAreaMiLocal", totalAreaMiLocal)

console.log("pipesAreaLocal", pipesAreaLocal)
console.log("whsAreaLocal", whsAreaLocal)
console.log("wldAreaLocal", wldAreaLocal)
console.log("tboAreaLocal", tboAreaLocal)
console.log("totalAreaOiLocal", totalAreaOiLocal)




   
  };

  useEffect(() => {
    const cropGroup = async () => {
      const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCropGroup/getAllCropGroupExtList`);
      setCropGroupData(result.data.dataContent);
    };
  
    cropGroup();
  }, []);
  
  
  const cropName = async (value) => {
    setCropGroupValue(value);
  
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCrop/getCropExtList`,
      {
        cropGroupCode: value,
      }
    );
    setCropNameData(result.data.dataContent);
  };
  
  const cropVariety = async (value) => {
    setCropNameValue(value);
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCropVariety/getCropVarietyExtList`,
      {
        // "cropGroupCode": cropGroupValue,
        cropCode: value,
      }
    );
    setCropVarietyData(result.data.dataContent);
  };

  const seriesAC2 = [
    {
      name: "Sprinkler",
      data: sprinklerArea,
    },
    {
      name: "Drip",
      data: dripArea,
    },
    {
      name: "Total of Mirco-Irrigation",
      data: totalAreaMi,
    },
  ];

  const seriesAC3 = [
    {
      name: "Pipes",
      data: pipesArea,
    },
    {
      name: "Water Harvesting Structures",
      data: whsArea,
    },
    {
      name: "Water Lifting Devices (Pumps)",
      data: wldArea,
    },
    {
      name: "Tubewell/Borewell/Openwell",
      data: tboArea,
    },
    {
      name: "Total of other Intervention",
      data: totalAreaOi,
    }
  ];

  const optionsAC2 = {
    chart: {
      type: "bar",
      height: 430,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: stateArray,
    },
  };

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function handleState(value) {
    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    // setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {
    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(value) {
    setDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      // subdistrictcode: value,
      districtcode: value,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleVillage(value) {
    // setSubDistrictValue(value);
    console.log("block code", blockValue);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleReset() {
    setStateValue("");
    setDistrictValue("");
    setSubDistrictValue("");
    setBlockValue("");
    setVillageValue("");
    setYearValue("");
    setCropGroupValue("");
    setCropNameValue("");
    setCropVarietyValue("");
  

    // setYearValue("");
    // setSeasonValue("");
    // setCropGroupValue("");
    // setCropNameValue("");
    // setCropVarietyValue("");

    fetchData("reset");
  }
  function handleToggleChart() {
    let toggle = !chartToggle
    setChartToggle(toggle)
  }
  function handleToggleChartSecond() {
    let toggle = !chartToggleSecond
    setChartToggleSecond(toggle)
  }
  const seriesAC1Pie = [23, 32, 56];

  const optionsAC1Pie = {
    chart: {
      height: 300,
      type: "pie",
    },
    labels: ["Bihar", "Delhi", "Uttar Pradesh"],
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  return (
    <>
      <PdmcUsecaseSidebar />
      <div className="page-wrapper chiller-theme toggled">
        <main id="main" className="main pdmcanalyticinner pdmcanalyticsdashboardss">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h5 className="text-white mb-0">PDMC Use Case</h5>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Admin</li>
                <li className="breadcrumb-item active">PDMC Usecase I</li>
              </ol>
            </nav>
            <Link className="btn btn-success" to="/Analytics">
              Back
            </Link>
          </div>

          <div className="card">
            <div className="card-body onbordedSchemess schemesreport">
                <h3>PDMC USE-CASE-II: STATE-WISE, CROP-WISE AND IRRIGATION TYPE WISE AREA IRRIGATED</h3>
              <div className="row">
              <div className="col-md-2">
                        <label htmlFor="year" className="form-label">
                          Financial Year
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setYearValue(e.target.value)}
                          value = {yearValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="2021-2022">2021-2022</option>
                          <option value="2022-2023">2022-2023</option>
                          <option value="2023-2024">2023-2024</option>
                        </select>
                      </div>         

                      <div className="col-md-2">
                        <label htmlFor="cropGroup" className="form-label">
                          Crop Group
                        </label>
                        <select
                          id="cropGroup"
                          required
                          className="form-select"
                          // onClick={cropName}
                          onChange={(e) => cropName(e.target.value)}
                          value={cropGroupValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropGroupData
                            ? cropGroupData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropGroupCode}>
                                    {" "}
                                    {item.cropGroupName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropName" className="form-label">
                          Crop Name
                        </label>
                        <select
                          id="cropName"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => cropVariety(e.target.value)}
                          value={cropNameValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropNameData
                            ? cropNameData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropCode}>
                                    {" "}
                                    {item.cropName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropVariety" className="form-label">
                          Crop Varietry
                        </label>
                        <select
                          id="cropVarietry"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => setCropVarietyValue(e.target.value)}
                          value={cropVarietyValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropVarietyData
                            ? cropVarietyData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropVarietyCode}>
                                    {" "}
                                    {item.cropVarietyName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>
                <div className="col-md-2">
                  <label htmlFor="State" className="form-label" id="StateLabel">
                    State
                  </label>
                  <select
                    id="State"
                    required
                    className="form-select"
                    onClick={getStates}
                    onChange={(e) => handleState(e.target.value)}
                    value={stateValue}
                    name="stateCode"
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {statesData
                      ? statesData.map((item, id) => {
                          return (
                            <option key={id} value={item.stateCode}>
                              {" "}
                              {item.stateName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label
                    htmlFor="District"
                    className="form-label"
                    id="DistrictLabel"
                  >
                    District
                  </label>
                  <select
                    id="District"
                    className="form-select"
                    onChange={(e) => handleBlock(e.target.value)}
                    value={districtValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>

                    {districtData
                      ? districtData.map((item, id) => {
                          return (
                            <option key={id} value={item.districtCode}>
                              {" "}
                              {item.districtName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                {/* <div className="col-md-2">
                        <label
                          htmlFor="subDistrict"
                          className="form-label"
                          id="subDistrictLabel"
                        >
                          SubDistrict
                        </label>
                        <select
                          id="subDistrict"
                          className="form-select"
                          onChange={(e) => handleBlock(e.target.value)}
                          value={subDistrictValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>

                          {subDistrictData.map((item, id) => {
                            return (
                              <option key={id} value={item.subDistrictCode}>
                                {" "}
                                {item.subDistrictName}
                              </option>
                            );
                          })}
                        </select>
                      </div> */}
                <div className="col-md-2">
                  <label htmlFor="Block" className="form-label" id="BlockLabel">
                    Block
                  </label>
                  <select
                    id="Block"
                    className="form-select"
                    onClick={handleVillage}
                    onChange={(e) => setBlockValue(e.target.value)}
                    value={blockValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {blockData
                      ? blockData.map((item, id) => {
                          return (
                            <option key={id} value={item.blockCode}>
                              {" "}
                              {item.blockName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="inputVillage" className="form-label">
                    Village
                  </label>
                  <select
                    id="Village"
                    className="form-select"
                    // onClick={handleVillage}
                    onChange={(e) => setVillageValue(e.target.value)}
                    value={villageValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {villageData
                      ? villageData.map((item, id) => {
                          return (
                            <option key={id} value={item.villageCode}>
                              {" "}
                              {item.villageName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2 mt-4 filterbtn">
                  <button
                    type="submit"
                    className="btn btn-submit btn-success"
                    onClick={fetchData}
                  >
                    Filter
                  </button>{" "}
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-outline-secondary"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
           
            </div>
          </div>
         
            <div className="card">
              <div className="card-body onbordedSchemess schemesreport pdmcanalyticsclasses">
              
                <div className="row">
                  <div className="col-md-6">
                  <button
                    type="text"
                    className="btn btn-outline-success btn-sm float-right"
                    onClick={() => handleToggleChart()}
                  >
                    <FontAwesomeIcon icon={chartToggle ? faPieChart : faBarChart} />{" "}
                  </button>
                  {
                    chartToggle ?  <div id="chart">
                      <h3 className="mb-2">State-Wise Area Covered by Sub Types of Micro Irrigation</h3>
                      <Chart
                        type="bar"
                        series={seriesAC2}
                        options={optionsAC2}
                        height={550}
                   
                      />
                    </div>
                    :
                    <Tabs>
                       <h3 className="mb-2">State-Wise Area Covered by Sub Types of Micro Irrigation</h3>
                     
                    <TabList>
                      
                      <Tab>Sprinkler</Tab>
                      <Tab>Drip</Tab>
                      <Tab>Total of Micro Irrigation</Tab>
                    </TabList>           
                   
                    <TabPanel>
                    {seriesAC1Pie != [] ? <>  <Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/></> : ""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <> <Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/></> :""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <><Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/> </>: ""} 
                    </TabPanel>
                  </Tabs>}
                  
                  </div>

                  <div className="col-md-6">
                  <button
                    type="text"
                    className="btn btn-outline-success btn-sm float-right"
                    onClick={() => handleToggleChartSecond()}
                  >
                    <FontAwesomeIcon icon={chartToggleSecond ? faPieChart : faBarChart} />{" "}
                  </button>
                  {
                    chartToggleSecond ?
                    <div id="chart">
                      <h3 className="mb-2">State-Wise Area Irrigated by Sub Activities of Other Interventions</h3>
                      <Chart
                        type="bar"
                        series={seriesAC3}
                        options={optionsAC2}
                        height={550}
                     
                      />
                    </div>:
                    <Tabs>
                     <h3 className="mb-2">State-Wise Area Irrigated by Sub Activities of Other Interventions</h3>
                    <TabList>
                      
                      <Tab>Pipes</Tab>
                      <Tab>Water Harvesting Structures</Tab>
                      <Tab>Water Lifting Devices (Pumps)</Tab>
                      <Tab>Tubewell/Borewell/Openwell</Tab>
                      <Tab>Total of other Intervention</Tab>
                    </TabList>           
                   
                    <TabPanel>
                    {seriesAC1Pie != [] ? <>  <Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/></> : ""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <> <Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/></> :""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <><Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/> </>: ""} 
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <><Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/> </>: ""} 
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <><Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/> </>: ""} 
                    </TabPanel>
                  </Tabs>}
                  </div>
                </div>
              </div>
            </div>
         
        </main>
      </div>
    </>
  );
}

export default PdmcAnalyticB;
